import React, { Component } from 'react';
import { Timeline } from 'antd';
import classnames from 'classnames'
import SvgIcon from 'SvgIcon';



const TimelineItem = Timeline.Item;

// 时间轴组件，支持excel配置
export default class TimeLine extends Component {
  constructor(props) {
    super(props);
    const { meta } = props;
    const { cStyle = {} } = meta;
    let config = {};
    if (cStyle) {
      config = JSON.parse(cStyle);
    }
    this.state = Object.assign(
      {
        rows: [],
        columns: {},
        pageInfo: {
          total: 0,
          current: 1,
          pageSize: 20,
          pageCount: 1
        },
        bLoading: true,
        enableRowClick: config.enableRowClick || false,
        cellStates: {},
        visible: true,
      },
      config
    );
    this.meta = props.meta;
    this.viewModel = props.viewModel;
    this.modelName = this.meta.childrenField
    if(props.model){
      this.model = props.model;
    }else{
      this.model = this.viewModel.getGridModel(this.modelName)
    }
    
    if (this.viewModel) this.viewModel.setState('override', false);
  }

  componentDidMount() {
    if (this.model) {
      this.model.addListener(this);
    }
    this.viewModel.on('updateViewMeta', this.updateViewMeta);
  }

  componentWillUnmount () {
    if (this.props.model)
    this.props.model.removeListener(this);
    this.viewModel.un('updateViewMeta', this.updateViewMeta);
  }

  updateViewMeta = (args) => {
    const { code, visible } = args;

    if (code != this.meta.cGroupCode) return;
    if (code && typeof visible == 'boolean') {
      this.setState({ visible })
    }
  }

  setListenerState = params => {
    // params.rows = [{"iRetailid":"1774085822903484422","logOperator":"昵称-马超","id":"2044223460335943681","logCorrespondTime":"2024-07-17 09:15:33","logLiveDeliveryStatus":{"value":"45","text":"制作完成","nameType":"text"},"_id":"rowId_4163"}]
    
    this.setState(Object.assign(params,{ bLoading: false }));
  };

  setDataSource = newRows => {
    // newRows = [{"iRetailid":"1774085822903484422","logOperator":"昵称-马超","id":"2044223460335943681","logCorrespondTime":"2024-07-17 09:15:33","logLiveDeliveryStatus":{"value":"45","text":"制作完成","nameType":"text"},"_id":"rowId_4163"}]
    const { dataSourceMode } = this.state;
    const { rows } = this.state;
    let isFromDetail = false;
    for (let j = 0; j < newRows.length; j++) {
      // 详情页面会发请求查看数据是否更改，先用id来标记
      for (let i = 0; i < rows.length; i++) {
        if (rows[i].id == newRows[j].id) {
          rows[i] = newRows[j];
          isFromDetail = true;
        }
      }
    }
    if (isFromDetail) {
      this.setState({ rows, bLoading: false });
      return;
    }
    let rowResult = [];
    if (dataSourceMode == 'local') {
      rowResult = newRows;
    } else {
      // dataSourceMode=="remote"
      rowResult = rows.concat(newRows);
    }
    this.setState({ rows: rowResult, bLoading: false });
  };

  // 设置分页
  setPageInfo = paginationlist => {
    const pageInfo = this.state.pageInfo;
    pageInfo.total = paginationlist.recordCount || 0;
    pageInfo.current = paginationlist.pageIndex;
    pageInfo.pageSize = paginationlist.pageSize;
    pageInfo.pageCount = Math.ceil(pageInfo.total / pageInfo.pageSize);
    this.setState({ pageInfo });
  };

  onJointQurty = (column, row) => {
    // 暂未使用 20221020
    if (!jDiwork || !jDiwork.openService) {
      const params = {
        mode: 'edit',
        readOnly: true,
        id: row.voucher_id
      };
      const data = {
        billtype: 'voucher',
        billno: row.voucher_billno,
        domainKey: row.dominkey,
        params: params
      };
      cb.loader.runCommandLine('bill', data, this.viewModel);
      this.viewModel.communication({ type: 'return' });
    } else {
      const dt = {
        billtype: 'voucher',
        billno: row.voucher_billno
      };
      const param = {
        data: {
          mode: 'edit',
          readOnly: true,
          id: row.voucher_id
        },
        title: row.voucher_billnanme,
        code: `${row.service_code}_pu_applyorder`
      };
      jDiwork.openService(row.service_code, dt, param);
    }
  };

  onCopy = (event, value) => {
    event.stopPropagation();
    const transfer = document.createElement('input');
    document.body.appendChild(transfer);
    transfer.value = value;
    transfer.select();
    document.execCommand('copy');
    document.body.removeChild(transfer);
    cb.utils.alert('复制成功', 'success');
  };

  getDescription = (row, columns, index) => {
    const controls = [];
    for (const key in columns) {
      const column = columns[key];

      const { cShowCaption, bJointQuery, cStyle } = column;
      const hasCopyBtn = JSON.parse(cStyle||'{}').hasCopy;
      const customClassname = JSON.parse(cStyle||'{}').className;
      if (row[key]) {
        controls.push(
          <div className={classnames('timeLine-step-line', customClassname)}>
            {cShowCaption ? <div className='name'>{cShowCaption}&nbsp;:&nbsp;</div> : null}
            <div className={classnames(this.state.theme == 'default' ? 'value' : 'values')}>
              <span>
                {bJointQuery ? (
                  <a onClick={() => this.onJointQurty(column, row)} >
                    {row[key].text || row[key]}
                  </a>
                ) : (
                  row[key].text || row[key]
                )}
              </span>
              {hasCopyBtn && <SvgIcon className='hasCopyBtnSvg' type='fuzhi' />}
            </div>
          </div>
        );
      }
    }
    if (controls.length) {
      return (
        <div className='timeLine-step-desc'>
          {controls}
          {this.state.enableRowClick && <span className='step_arrow' />}
        </div>
      );
    } else {
      return <div className='timeLine-step-desc'>无数据</div>;
    }
  };

  onScroll = e => {
    const { dataSourceMode } = this.state;
    if (dataSourceMode == 'local') {
      // 本地数据无需分页
      return;
    }
    const y = e.target.scrollTop;
    const scrollBody = this.scrollBody;
    const scrollHeight = scrollBody.scrollHeight;
    const clientHeight = scrollBody.clientHeight;
    if (y >= scrollHeight - clientHeight - 100) {
      const { current, pageCount } = this.state.pageInfo;
      if (!this.state.bLoading && current < pageCount) {
        this.model.setPageIndex(current + 1);
        this.setState({ bLoading: true });
      }
    }
  };

  getStepControl = (rows, columns) => {
    const controls = [];
    const columnsResult = { ...columns };
    // 状态（标题中）
    let tagColumn = columns.tag;
    let tagKey = null;
    if (!tagColumn) {
      for (const key in columns) {
        const type = JSON.parse(columns[key].cStyle||'{}').type;
        const cControlType = columns[key].cControlType.toLocaleLowerCase();
        if (type == 'tag' && (cControlType == 'select' || cControlType == 'input')) {
          tagColumn = columns[key];
          tagKey = key;
          break;
        }
      }
    }
    rows.forEach((row, index) => {
      let title = '';
      let titleClassName = '';
      let tagCom = null;
      let tagData = null;
      let tagColumnLowerCase=null;
      if(!tagColumn){
        tagColumn = null;
      }else if(tagColumnLowerCase == 'input' || tagColumnLowerCase == 'select'){
        tagData = row[tagColumn.cItemName];
        // select类型，格式为{value: '2', text: '高', nameType: 'text', icon: 'yxc_graystate_timeLine'}
        tagColumnLowerCase = tagColumn.cControlType.toLocaleLowerCase()   
        const tagClassname = JSON.parse(tagColumn.cStyle||'{}').className;
        if (row[tagColumn.cItemName]) {
          tagCom = (
            <span data-value={`${tagColumn.cItemName}-${tagData.value || tagData}`} className={classnames({ 'timeline-tag': true, [tagClassname]: true, [tagData.icon]: tagData.icon })}>
              {tagData.text || tagData}
            </span>
          );
        }
      }else {
        tagCom = <div>tag需要配置为select/input类型</div>;
      }
      for (const key in columns) {
        title = row[key].text || row[key]; // controls第一条作为title,兼容select形式
        this.titleKey = key;
        titleClassName = columnsResult[key] && JSON.parse(columnsResult[key].cStyle||'{}').className
        delete columnsResult[key];
        break;
      }
      title = (
        <div className={classnames('timeLine-step-title', titleClassName)}>
          {title}
          <span className='handle-step-order-status'>{tagCom}</span>
        </div>
      );
      delete columnsResult.tag;
      if (tagKey) {
        delete columnsResult[tagKey];
      }
      const desc = this.getDescription(row, columnsResult, index);
      const customerDot = (
        <div style={{
          width: '6px',
          height: '6px',
          'background-color': this.state.currentNode === 'first' && index === 0 ? this.state.currentColor || '#588CE9' : '',
          'border-radius': '50%',
          'box-sizing': 'content-box'
        }}
        />
      );
      controls.push(
        <TimelineItem
          // fieldid={cb.utils.getFieldID({ model: this.viewModel, cItemName: 'TimelineItemRow', index })}
          onClick={() => {
            this.model.execute('rowClick', row);
          }}
          dot={customerDot}
        >
          {title}
          {desc}
        </TimelineItem>
      );
    });
    return controls;
  };

  render() {
    const { rows, columns, bLoading, className, visible } = this.state;
    if (!visible) {
      return null
    }
    // 卡片页面只有浏览态显示
    // let { billType = '', mode } = this.viewModel?.getParams();
    // billType = billType.trim().toLowerCase();
    // if ((billType == 'voucher' || billType == 'archive') && mode !== 'browse') {
    //   return null;
    // }
    const stepControl = this.getStepControl(rows, columns);
    let doneText = '已经到底了~'; /* "已经到底了~" */
    if (bLoading) {
      doneText = '数据加载中~';
    } else {
      if (rows.length == 0) {
        return (
          <div className='no_data_box' style={{margin: '30px', textAlign: 'center'}}>
             <SvgIcon type="nodata" />
            暂无数据
          </div>
        );
      }
      // if (document.getElementsByClassName('ys-timeline-container')?.[0]?.offsetHeight < document.getElementsByClassName('meta-dynamic-view')?.[0]?.offsetHeight) {
      //   doneText = ''
      // }
    }
    return (
      <div
      ref={ref => {
      this.scrollBody = ref;
      }}
      onScroll={this.onScroll}
      className={classnames('ys-timeline-container', className)}
      style={{ 'max-height': window.innerHeight * 0.8 }}
     >
        <Timeline className='ys-timeline' direction='vertical'>
          {stepControl}
        </Timeline>
        <div className='doned'>{doneText}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/TimeLine.jsx